import {AgentLicense} from "./AgentLicense";
import {AgentOfficePhone} from "./Agent";
import {MediaWithType} from "./MediaWithType";

export enum AgentSignatureType {
  AGENT = "AGENT",
  AGENCY = "AGENCY"
}

export enum AgentSignatureFormat {
  DIGITAL = "DIGITAL",
  PRINT = "PRINT"
}

export enum AgentSignatureElement {
  DISPLAY_NAME = "DISPLAY_NAME",
  BRAND_NAME = "BRAND_NAME",
  BROKERAGE = "BROKERAGE",
  ADDRESS = "ADDRESS",
  EMAIL_ID = "EMAIL_ID",
  PHONE = "PHONE",
  OFFICE_PHONE = "OFFICE_PHONE",
  LICENSE = "LICENSE",
  CUSTOM_SIGNATURE_TEXT = "CUSTOM_SIGNATURE_TEXT",
  WEBSITE = "WEBSITE",
  USER_FULL_NAME = "USER_FULL_NAME",
  USER_EMAIL = "USER_EMAIL",
  USER_PHONE = "USER_PHONE",
  USER_OFFICE_PHONE = "USER_OFFICE_PHONE",
  USER_LICENSE = "USER_LICENSE",
  USER_SIGNATURE_FIELD = "USER_SIGNATURE_FIELD",
  CUSTOM_TEXT = "CUSTOM_TEXT",
  CUSTOM_EMAIL = "CUSTOM_EMAIL",
  CUSTOM_PHONE = "CUSTOM_PHONE"
}
export const AgentSignatureElementLabel: Partial<Record<AgentSignatureElement, string>> = {
  [AgentSignatureElement.DISPLAY_NAME]: "Signature Display Name",
  [AgentSignatureElement.BRAND_NAME]: "Brand Name",
  [AgentSignatureElement.BROKERAGE]: "Brokerage Name",
  [AgentSignatureElement.ADDRESS]: "Address",
  [AgentSignatureElement.EMAIL_ID]: "Email",
  [AgentSignatureElement.PHONE]: "Mobile Phone",
  [AgentSignatureElement.OFFICE_PHONE]: "Office Phone",
  [AgentSignatureElement.LICENSE]: "License #",
  [AgentSignatureElement.CUSTOM_SIGNATURE_TEXT]: "Custom Signature Field",
  [AgentSignatureElement.WEBSITE]: "Website URL"
};
export type AgentSignatureElementToDataMapTypeInstance = {
  [AgentSignatureElement.DISPLAY_NAME]: string;
  [AgentSignatureElement.BRAND_NAME]: string;
  [AgentSignatureElement.BROKERAGE]: string;
  [AgentSignatureElement.ADDRESS]: string;
  [AgentSignatureElement.EMAIL_ID]: string;
  [AgentSignatureElement.PHONE]: string;
  [AgentSignatureElement.OFFICE_PHONE]: AgentOfficePhone;
  [AgentSignatureElement.LICENSE]: AgentLicense;
  [AgentSignatureElement.CUSTOM_SIGNATURE_TEXT]: string;
  [AgentSignatureElement.WEBSITE]: string;
  [AgentSignatureElement.USER_FULL_NAME]: string;
  [AgentSignatureElement.USER_EMAIL]: string;
  [AgentSignatureElement.USER_SIGNATURE_FIELD]: string;
  [AgentSignatureElement.USER_PHONE]: string;
  [AgentSignatureElement.USER_OFFICE_PHONE]: AgentOfficePhone;
  [AgentSignatureElement.USER_LICENSE]: AgentLicense;
  [AgentSignatureElement.CUSTOM_TEXT]: string;
  [AgentSignatureElement.CUSTOM_EMAIL]: string;
  [AgentSignatureElement.CUSTOM_PHONE]: string;
};
export type AvailableSignatureElementTypes = keyof AgentSignatureElementToDataMapTypeInstance;

export type SignatureElementDataType<SignatureElementType extends AvailableSignatureElementTypes> =
  AgentSignatureElementToDataMapTypeInstance[SignatureElementType];
export interface AgentSignatureElementSettings<SignatureElementType extends AvailableSignatureElementTypes> {
  type: SignatureElementType;
  value: SignatureElementDataType<SignatureElementType>;
}

export interface AgentSignature {
  type: AgentSignatureType;
  format: AgentSignatureFormat;
  photo?: MediaWithType;
  signatureElementsSettings: AgentSignatureElementSettings<AvailableSignatureElementTypes>[];
}
